import type { Href } from "../router";

export const isNoopHref = (href: Href): boolean => href === "#" || href === "";

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);
